import { createClient } from '@supabase/supabase-js';

// Inserisci le tue chiavi di Supabase
const supabaseUrl = 'https://umqhvmiqixcbmhshuusq.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVtcWh2bWlxaXhjYm1oc2h1dXNxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkzNjkyMTgsImV4cCI6MjA1NDk0NTIxOH0.iTrZ4h4IJlz4xgLIRE4ntHwEcBzskSqtrZg6aykJguk';

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
